import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import AlertDialog from '../components/alert_dialog';
import { Typography } from '@mui/material';
import WarningIcon from '../assets/images/warning.svg';
import { handleLogout } from './common';

export const showSessionExpiredModal = (onContinue, timeRemainingMs = 5 * 60 * 1000) => {
  const modalRoot = document.createElement('div');
  modalRoot.id = 'session-expired-modal';
  document.body.appendChild(modalRoot);

  const root = createRoot(modalRoot);

  const SessionExpiredModal = () => {
    const [secondsLeft, setSecondsLeft] = useState(Math.floor(timeRemainingMs / 1000));
    const [openDialog, setOpenDialog] = useState(true);

    // Countdown without using localStorage
    useEffect(() => {
      if (secondsLeft <= 0) {
        return;
      }

      const interval = setInterval(() => {
        setSecondsLeft(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }, [secondsLeft]);

    const handleAction = () => {
      if (secondsLeft > 0) {
        setOpenDialog(false);
        if (onContinue) onContinue();
      } else {
        handleLogout();
      }
    };

    const handleCancelLogoutAction = () => {
      handleLogout();
    };

    const formatTime = (seconds) => {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    return (
      <AlertDialog
        openDialog={openDialog}
        handleAction={handleAction}
        loadingText="Redirecting..."
        actionText={secondsLeft ? 'Continue Session' : 'Login'}
        noCancelBtn={!secondsLeft}
        noCloseIcon={!secondsLeft}
        backdropClose
        backdropColor={'grey'}
        handleCancelBtn={handleCancelLogoutAction}
        cancelBtnText="Logout Now"
        dialogActionBtnStyles="w-full flex justify-center items-center"
        children={
          <div className="flex flex-col justify-center items-center gap-2">
            <img src={WarningIcon} alt="Warning" />
            <Typography fontWeight={600} color="#2A2A2A">
              {!secondsLeft ? 'Session Timeout!' : 'You will be logged out soon'}
            </Typography>
            <Typography
              fontSize={12}
              color="#2A2A2A"
              whiteSpace="normal"
              className="w-75 text-center"
            >
              {!secondsLeft
                ? 'You have been logged out due to inactivity'
                : 'For your security, we log you out automatically when you have not been active for a certain period of time.'}
            </Typography>
            {secondsLeft > 0 && (
              <Typography
                className="flex flex-wrap items-center gap-2 text-charcoal font-bold"
                fontSize={16}
              >
                {formatTime(secondsLeft)}
              </Typography>
            )}
          </div>
        }
      />
    );
  };

  root.render(<SessionExpiredModal />);

  return () => {
    root.unmount();
    modalRoot.remove();
  };
};
